import { maxBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { MODAL_CLASSNAME, MODAL_OVERLAY_CLASSNAME } from './constants/classnames';

export const ModalStyles = createGlobalStyle`
  .${MODAL_CLASSNAME} {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.5);
    box-sizing: content-box;
    outline: none;
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    height: calc(100% - 40px);
    width: 576px;
    position: relative;
    top: 20px;
    margin: 0 auto;

    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        width: 100%;
        height: 100%;
        border-radius: 0;
        top: 0px;
        bottom: 0px;
      `,
    )}

    > iframe {
      display: block;
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
      border: 0;
      outline: none;
    }
  }

  .${MODAL_OVERLAY_CLASSNAME} {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 600;
    background-color: rgba(30, 30, 41, 0.2);

    &:focus {
      outline: none;
    }
  }
`;
